export default __webpack_public_path__ + "static/media/educational.b77bc614.png";